import React, { Component } from "react";
import ReactDOM from "react-dom/client";
import WidgetRenderer from "./WidgetRenderer";
import WidgetDrillDownHelper from "./WidgetDrillDownHelper";
import { scrollDashboardToTop, preparefilter, extractFilterValues, prepareMultiFilter, cleanFilterParams } from "./DashboardUtils";
import "./WidgetStyles.css";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.core = this.props.core;
    this.proc = this.props.proc;
    this.renderedWidgetElement = [] //contains the root : element where mounting is happpening
    this.state = {
      htmlData: this.props.htmlData ? this.props.htmlData : null,
      dashboardFilter: this.props.dashboardFilter ? this.props.dashboardFilter : [],
      preparedDashboardFilter: null,
      drilldownDashboardFilter: this.props.drilldownDashboardFilter || [],
    };
    this.content = this.props.content;
    this.renderedWidgets = {};
    var uuid = "";
    if (this.props.uuid) {
      uuid = this.props.uuid;
    }
    if (this.props.content) {
      var content = this.props.content;
      if (content && content.uuid) {
        uuid = content.uuid;
      }
    }
    this.uuid = uuid;
    this.dashboardDivId = "dashboard_" + this.uuid;
    this.loader = this.core.make("oxzion/splash");
    this.helper = this.core.make("oxzion/restClient");
    this.alertAdapter = this.core?.make("oxzion/alert");

    // this.props.proc?.on("destroy", () => {
    //   this.removeScriptsFromDom();
    // });
    this.myRef = React.createRef();
  }

  async getDashboardHtmlDataByUuid(uuid) {
    let response = await this.helper.request("v1", "analytics/dashboard/" + uuid, {}, "get");
    return response;
  }

  /**
   *
   * @param {string} uuid
   * @param {Object<{data, filterKey, filterCondition (optional)}>} filterParams
   * @returns
   */
  getWidgetByUuid = async (uuid, filterParams) => {
    const { data, filterKey, filterCondition } = this.props.customDashboardData || {};
    try {
      if (data && filterKey) {
        if (!filterParams.length || (filterParams.length > 0 && typeof filterParams[0] === "object") || !filterParams.flat?.().join("")?.includes(`${filterKey}=${data}`)) {
          if (filterParams.length > 0) {
            filterParams.push("AND");
            filterParams.push([filterKey, filterCondition || "eq", data]);
          } else {
            filterParams = [[filterKey, filterCondition || "eq", data]];
          }
        }
      }
    } catch (e) {}
    
    // Clean filter parameters before sending to backend
    const cleanedParams = cleanFilterParams(filterParams) || [];
    let filterParameter = cleanedParams.length > 0 ? "&filter=" + JSON.stringify(cleanedParams) : "";
    
    // send this filters to widgets as well so that we can append those to the url that we are trying to create
    let response = await this.helper.request("v1", "analytics/widget/" + uuid + "?data=true" + filterParameter, {}, "get");
    return response;
  };

  extractFilter() {
    let stack = this.props.dashboardStack;
    let filter = stack[stack.length - 1].drilldownDashboardFilter;
    let filterText = "";
    for (let i = 0; i < filter.length; i++) {
      filterText != "" && (filterText += " ");
      filterText += filter[i];
    }
    return filterText;
  }

  appendToDashboardContainer(htmlData) {
    let backButton = "";
    let dashboardFilterDescription = "";
    if (this.props.dashboardStack && this.props.dashboardStack.length > 1) {
      //rendering back button for drilled down dashboard
      let dashboardTitle = this.props.dashboardStack[this.props.dashboardStack.length - 1]["drilldownDashboardTitle"];
      let finalDashboardTitle = dashboardTitle ? dashboardTitle : "";
      // backButton = `<div id='dashboard-rollup-button' title="Previous OI" class='dashboard-rollup-button'><i class='fa fa-arrow-circle-left'  aria-hidden='true'></i>  </div>`;
      if (dashboardTitle || dashboardTitle == "") {
        dashboardFilterDescription = "<div class='badge badge-info dashboard-filter-description' id='dashboard-drilldown-title'>" + finalDashboardTitle + "</div>";
      } else {
        dashboardFilterDescription = "";
      }
    }
    let container =
      "<div id='dasboard-viewer-wrapper' class='dasboard-viewer-wrapper'>" +
      "<div id='dashboard-drilldown-info-wrapper' class='dashboard-drilldown-info-wrapper'>" +
      dashboardFilterDescription +
      backButton +
      "</div>" +
      "<div id='dasboard-viewer-content' class='dasboard-viewer-content'>" +
      htmlData +
      "</div>" +
      "</div>";
    return container;
  }

  setupDrillDownListeners() {
    let rollUpDiv = "dashboard-rollup-button-" + this.props.uuid;
    if (document.getElementById(rollUpDiv)) {
      let backbutton = document.getElementById(rollUpDiv);
      backbutton.addEventListener("click", (event) => {
        this.props.rollupToDashboard();
      });
    }
  }

  loadDashboardData() {
    let extractedFilterValues = extractFilterValues(this.props.dashboardFilter, this.props.dashboardStack, this.props.loadDefaultFilters ? "default" : undefined);

    let drilldownDashboardFilter = extractedFilterValues.length == 1 ? extractedFilterValues[0] : extractedFilterValues;
    if (extractedFilterValues && extractedFilterValues.length > 1) {
      drilldownDashboardFilter = extractedFilterValues[0];
      drilldownDashboardFilter = prepareMultiFilter(drilldownDashboardFilter);
      for (let i = 1; i < extractedFilterValues.length; i++) {
        drilldownDashboardFilter = preparefilter(drilldownDashboardFilter, extractedFilterValues[i]);
      }
    }
    
    // Use priority order for filter selection
    if (this.props.drilldownDashboardFilter && this.props.drilldownDashboardFilter.length > 0) {
      this.updateGraph(this.props.drilldownDashboardFilter, true);
    } else if (this.props.widgetFilter && this.props.widgetFilter.length > 0) {
      this.updateGraph(this.props.widgetFilter, true);
    } else {
      this.updateGraph(drilldownDashboardFilter, true);
    }
  }

  componentDidMount() {
    let customEventHandlers = {
      unmountWidgets: () => {
        this.unmountWidgets()
      },
    };
    for (const key in customEventHandlers) {
      document.getElementById(this.props.appNavigationDiv)?.addEventListener(key, customEventHandlers[key], false);
    }
    if (this.uuid) {
      this.getDashboardHtmlDataByUuid(this.uuid)
        .then((response) => {
          if (response.status == "success") {
            this.setState(
              {
                htmlData: response.data.dashboard.content ? response.data.dashboard.content : null,
              },
              () => {
                this.setupDrillDownListeners();
                this.loadDashboardData();
              },
            );
          } else {
            this.setState({ htmlData: `<p>No Data</p>` });
          }
        })
        .catch(function (response) {
          console.error("Could not load widget.", response);
          this.alertAdapter?.show({
            title: "Oops ...",
            text: "Could not load widget. Please try after some time.",
            confirmButtonText: "Got it",
            icon: "error",
          });
        });
    } else if (this.state.htmlData != null) {
      this.props.drilldownDashboardFilter.length > 0 ? this.updateGraph(this.props.drilldownDashboardFilter) : this.updateGraph();
    }
    window.removeEventListener("message", this.widgetDrillDownMessageHandler, false); //avoids dupliacte event handalers to be registered
    window.addEventListener("message", this.widgetDrillDownMessageHandler, false);
    scrollDashboardToTop();
  }

  unmountWidgets = () => {
    this.renderedWidgetElement.forEach(object => {
      //unmounting needs to be async
      object.root.unmount(object.element)
    })
  }

  componentWillUnmount() {
    this.unmountWidgets()
    for (let elementId in this.renderedWidgets) {
      let widget = this.renderedWidgets[elementId];
      if (widget) {
        if (widget.dispose) {
          widget.dispose();
        }
        delete this.renderedWidgets[elementId];
      }
    }
    window.removeEventListener("message", this.widgetDrillDownMessageHandler, false);
  }

  updateGraphWithFilterChanges(applyFilter) {
    //appliedFitlers are the filters applied by the user, they will already contain the drillDownDashboardFilter hence no need to spread it
    const drillDownFilters = this.props.appliedFilters || this.props.drilldownDashboardFilter //when stepping down, appliedFilters is null while drilldownDashboardFilter is populated
    
    // Clean drilldown filters before processing
    const cleanedDrillDownFilters = cleanFilterParams(drillDownFilters) || [];
    
    if (cleanedDrillDownFilters.length > 0) {
      this.setState(
        {
          preparedDashboardFilter: cleanedDrillDownFilters,
        },
        () => {
          this.updateGraph(this.state.preparedDashboardFilter, applyFilter);
        },
      );
    } else {
      this.setState(
        {
          preparedDashboardFilter: [],
        },
        () => {
          this.updateGraph(null, applyFilter);
        },
      );
    }
  }

  componentDidUpdate(prevProps) {
    //update component when filter is changed
    if (JSON.stringify(prevProps.dashboardFilter) != JSON.stringify(this.props.dashboardFilter)) {
      this.updateGraphWithFilterChanges(true);
    }
  }

  updateGraph = async (filterParams, applyFilters) => {
    // Clean and validate filter parameters before processing
    const cleanedFilterParams = cleanFilterParams(filterParams) || [];

    var that = this;
    if (null === that.state.htmlData) {
      return;
    }
    let root = document;
    var widgets = root.getElementsByClassName("oxzion-widget");
    let errorFound = false;
    //! Could dispose widgets directly in the 2nd for loop, but not working - investigate
    for (let elementId in that.renderedWidgets) {
      const widget = this.renderedWidgetElement[elementId]
      if(widget) {
        widget?.dispose?.();
        delete that.renderedWidgets[elementId];
      }
    }
    if (widgets?.length > 0) {
      for (let widget of widgets) {
        //only update widget matching uuid of current dashboard component
        if (widget.hasAttribute(WidgetDrillDownHelper.CTX_DASHBOARD_ID) && widget.getAttribute(WidgetDrillDownHelper.CTX_DASHBOARD_ID) !== that.uuid) continue;
        var attributes = widget.attributes;
        //dispose
        var widgetUUId = attributes[WidgetDrillDownHelper.OXZION_WIDGET_ID_ATTRIBUTE]?.value;
        if(widgetUUId) {
          // Use cleaned filter params for API call
          that.getWidgetByUuid(widgetUUId, cleanedFilterParams).then((response) => {
            if (response.status == "success") {
              //dispose if widget exists
              let hasDashboardFilters = that.state.preparedDashboardFilter ? true : false;
              let renderproperties = {
                element: widget,
                widget: response.data.widget,
                hasDashboardFilters: hasDashboardFilters,
                dashboardEditMode: false,
              };
              document.getElementById(this.dashboardDivId)?.dispatchEvent(new CustomEvent("clearEvalCache", { bubbles: true }));
              if (response.data?.widget?.exclude_overrides || applyFilters) {
                // Use cleaned filter params for widget rendering too
                let widgetObject = WidgetRenderer.render(renderproperties, widgetUUId, cleanedFilterParams, that.core, that.uuid, that.props);
                if (widgetObject) {
                  if (React.isValidElement(widgetObject)) {
                    const gridRoot = ReactDOM.createRoot(renderproperties.element);
                    try {
                      that.renderedWidgetElement.push({
                        root: gridRoot,
                        element: renderproperties.element,
                      });
                    } catch (err) {
                      console.log(err);
                    }
                    gridRoot.render(widgetObject);
                  }
                  that.renderedWidgets[widgetUUId] = widgetObject;
                }
              }
            } else if (response.status === "error") {
              console.error("Could not load widget.", response);
              errorFound = true;
            }
          });
        }
      }
    }
    if (errorFound) {
      that.alertAdapter?.show({
        title: "Oops ...",
        text: "Could not load one or more widget(s). Please try after some time.",
        confirmButtonText: "Got it",
        icon: "error",
      });
      return;
    }
  };

  async drillDownToDashboard(data) {
    let event = {};
    let elementId = data.elementId;
    //starting spinner
    if (elementId) {
      var widgetDiv = document.getElementById(elementId);
      this.loader.show();
    }
    let dashboardData = await this.getDashboardHtmlDataByUuid(data.dashboard);

    let dashboardStack = this.props.dashboardStack ? JSON.parse(JSON.stringify(this.props.dashboardStack)) : [];
    let dashboardStackDrilldownFilter = dashboardStack.length > 0 ? dashboardStack[dashboardStack.length - 1]["drilldownDashboardFilter"] : null;
    let dashboardFilter = dashboardStackDrilldownFilter != null && dashboardStackDrilldownFilter.length > 0 ? dashboardStackDrilldownFilter : [];
    let widgetFilter = JSON.parse(data.filter);
    let drilldownDashboardFilter = dashboardFilter;
    let drilldownDashboardTitle = data.dashboardTitle;
    event.value = JSON.stringify(dashboardData.data.dashboard);

    if (this.state.preparedDashboardFilter !== null) {
      if (this.state.preparedDashboardFilter.length > 0 && widgetFilter.length > 0) drilldownDashboardFilter = [widgetFilter, "AND", this.state.preparedDashboardFilter]
      else drilldownDashboardFilter = widgetFilter;
      event.dashboardFilter = this.state.preparedDashboardFilter;
    } else if (dashboardFilter.length > 0) {
      // combining dashboardfilter with widgetfilter
      drilldownDashboardFilter = preparefilter(widgetFilter, dashboardFilter);
      event.dashboardFilter = dashboardFilter;
    } else {
      // Fix: Assign widget filter to drilldown filter when no existing filters
      drilldownDashboardFilter = widgetFilter;
    }
    event.drilldownDashboardFilter = drilldownDashboardFilter;
    event.drilldownDashboardTitle = drilldownDashboardTitle;
    event.widgetFilter = widgetFilter;

    if (elementId) {
      var widgetDiv = document.getElementById(elementId);
      this.loader.destroy();
    }
    this.props.drilldownToDashboard(event, "dashname");
  }

  widgetDrillDownMessageHandler = (event) => {
    let eventData = event.data;
    //only drill down widget matching current dashboard uuid
    if (eventData.hasOwnProperty(WidgetDrillDownHelper.CTX_DASHBOARD_ID) && eventData[WidgetDrillDownHelper.CTX_DASHBOARD_ID] !== this.uuid) return;
    if (eventData.target == "dashboard") {
      this.drillDownToDashboard(eventData);
    }
    let action = eventData[WidgetDrillDownHelper.MSG_PROP_ACTION];
    if (action !== WidgetDrillDownHelper.ACTION_DRILL_DOWN && action !== WidgetDrillDownHelper.ACTION_ROLL_UP) {
      return;
    }
    let target = eventData[WidgetDrillDownHelper.MSG_PROP_TARGET];
    if (target && target !== "widget") {
      return;
    }
    var thiz = this;

    function cleanup(elementId) {
      let widget = thiz.renderedWidgets[elementId];
      if (widget) {
        if (widget.dispose) {
          widget.dispose();
        }
        delete thiz.renderedWidgets[elementId];
      }
    }

    let elementId = eventData[WidgetDrillDownHelper.MSG_PROP_ELEMENT_ID];
    let widgetId = eventData[WidgetDrillDownHelper.MSG_PROP_WIDGET_ID];
    cleanup(elementId);
    let nextWidgetId = eventData[WidgetDrillDownHelper.MSG_PROP_NEXT_WIDGET_ID];
    if (nextWidgetId) {
      widgetId = nextWidgetId;
    }

    let url = `analytics/widget/${widgetId}?data=true`;
    let filter = eventData[WidgetDrillDownHelper.MSG_PROP_FILTER];

    // console.log("Printing Filter: " + this.state.preparedDashboardFilter)
    //apply dashboard filter if exists
    if (this.state.preparedDashboardFilter) {
      let preparedFilter;
      if (this.state.preparedDashboardFilter.length > 0) {
        //combining dashboardfilter with widgetfilter
        preparedFilter = filter ? preparefilter(this.state.preparedDashboardFilter, JSON.parse(filter)) : this.state.preparedDashboardFilter;
      } else {
        preparedFilter = filter ? JSON.parse(filter) : "";
      }
      filter = preparedFilter;
      if (filter && "" !== filter) {
        url = url + "&filter=" + JSON.stringify(filter);
      } else {
        url = url;
      }
    } else if (this.props.dashboardStack && this.props.dashboardStack.length > 0) {
      let dashFilter = this.props.dashboardStack[this.props.dashboardStack.length - 1]["drilldownDashboardFilter"];
      let preparedFilter = null;
      if (filter) {
        if (dashFilter && dashFilter.length > 0) {
          preparedFilter = preparefilter(dashFilter, JSON.parse(filter));
        } else {
          preparedFilter = JSON.parse(filter);
        }
      } else {
        preparedFilter = dashFilter;
      }
      filter = preparedFilter;
      url = url + "&filter=" + JSON.stringify(filter);
    } else if (filter && "" !== filter) {
      url = url + "&filter=" + encodeURIComponent(filter);
    } else {
      url = url;
    }
    //starting spinner
    if (eventData.elementId) {
      var widgetDiv = document.getElementById(eventData.elementId);
      this.loader.show(widgetDiv);
    }
    var self = this;
    let element = document.getElementById(elementId);
    this.helper
      .request("v1", url, null, "get")
      .then((response) => {
        let renderproperties = {
          element: element,
          widget: response.data.widget,
          props: eventData,
          dashboardEditMode: false,
        };
        let widgetObject = WidgetRenderer.render(renderproperties, undefined, undefined, this.core, this.uuid, this.props);
        if (widgetObject) {
          self.renderedWidgets[elementId] = widgetObject;
        }
        if (eventData.elementId) {
          var widgetDiv = document.getElementById(eventData.elementId);
        }
        this.loader.destroy(element);
      })
      .catch((response) => {
        this.loader.destroy(element);
        this.alertAdapter?.show({
          title: "Oops...",
          text: "Could not fetch the widget data. Please try after some time.",
          confirmButtonText: "Got it",
          icon: "error",
        });
        if (eventData.elementId) {
          var widgetDiv = document.getElementById(eventData.elementId);
        }
      });
  };

  render() {
    return (
      <div
        ref={this.myRef}
        id={this.dashboardDivId}
        dangerouslySetInnerHTML={{
          __html: this.appendToDashboardContainer(this.state.htmlData ? this.state.htmlData : ""),
        }}
      />
    );
  }
}

export default Dashboard;
